export const CORE_SHARE_TYPES = {
  tag: 'tag',
  album: 'album',
  file: 'file',
  person: 'person',
  digiProject: 'digiProject',
  digiFile: 'digiFile',
  profile: 'profile',
  container: 'container'
};

export const CORE_LIST_SCROLL_THRESHOLD_EVENT = 'core-list-scroll-threshold';
export const CORE_LIST_SCROLL_THRESHOLD_DEFAULT = 500;
